module.exports = __webpack_public_path__ + "img/fr.966df461.jpeg";